// ** React Imports
import { useState, Fragment } from 'react';

// ** Reactstrap Imports
import { Button, ListGroup, ListGroupItem } from 'reactstrap';

// ** Third Party Imports
import { useDropzone } from 'react-dropzone';
import { FileText, X } from 'react-feather';

const FileUploaderSingle = ({
  children,
  handleSubmit,
  accept,
  show = true,
  reset,
  autosubmit = false
}) => {
  // ** State
  const [files, setFiles] = useState([]);

  const { getRootProps, getInputProps } = useDropzone({
    multiple: false,
    onDropAccepted: (acceptedFiles) => {
      if (autosubmit) handleSubmit([...acceptedFiles.map((file) => Object.assign(file))]);
      else setFiles([...acceptedFiles.map((file) => Object.assign(file))]);
    },
    maxFiles: 1,
    accept,
    disabled: !show
  });

  const renderFilePreview = (file) => {
    if (file.type.startsWith('image')) {
      return (
        <img
          className="rounded"
          alt={file.name}
          src={URL.createObjectURL(file)}
          height="28"
          width="28"
        />
      );
    } else {
      return <FileText size="28" />;
    }
  };

  const handleRemoveFile = (file) => {
    const uploadedFiles = files;
    const filtered = uploadedFiles.filter((i) => i.name !== file.name);
    setFiles([...filtered]);
  };

  const renderFileSize = (size) => {
    if (Math.round(size / 100) / 10 > 1000) {
      return `${(Math.round(size / 100) / 10000).toFixed(1)} mb`;
    } else {
      return `${(Math.round(size / 100) / 10).toFixed(1)} kb`;
    }
  };

  const fileList = files.map((file, index) => {
    if (index === 0) {
      return (
        <ListGroupItem
          key={`${file.name}-${index}`}
          className="d-flex align-items-center justify-content-between"
        >
          <div className="file-details d-flex align-items-center">
            <div className="file-preview me-1">{renderFilePreview(file)}</div>
            <div>
              <p className="file-name mb-0">{file.name}</p>
              <p className="file-size mb-0">{renderFileSize(file.size)}</p>
            </div>
          </div>
          <Button
            color="danger"
            type="button"
            outline
            size="sm"
            className="btn-icon"
            onClick={() => handleRemoveFile(file)}
          >
            <X size={14} />
          </Button>
        </ListGroupItem>
      );
    }
  });

  if (!children) {
    return null;
  }
  return (
    <>
      <div {...getRootProps({ className: 'dropzone' })}>
        <input {...getInputProps()} />
        <div className="d-flex align-items-left justify-content-center flex-column">
          {children}
        </div>
      </div>
      {files.length && show ? (
        <Fragment>
          <ListGroup className="my-2">{fileList}</ListGroup>
          <div className="d-flex justify-content-end">
            <Button
              type="button"
              color="primary"
              onClick={() => handleSubmit(files)}
            >
              Subir Archivo
            </Button>
          </div>
        </Fragment>
      ) : null}

      {!show && reset && (
        <Fragment>
          <div className="d-flex justify-content-end">
            <Button type="button" color="primary" onClick={() => reset()}>
              Reiniciar
            </Button>
          </div>
        </Fragment>
      )}
    </>
  );
};

export default FileUploaderSingle;
